import { helpers } from 'vuelidate/lib/validators'

export const tag = value => !helpers.req(value) || /^[a-zA-Z-_]+$/.test(value)
